import dynamic from 'next/dynamic';

export const AppSmallBanner = dynamic(() => import('./organisms/AppSmallBanner/index').then(mod => mod.AppSmallBanner));
export const AppHomepageHero = dynamic(() =>
  import('./organisms/AppHomepageHero/index').then(mod => mod.AppHomepageHero)
);
export const OffersAppContainer = dynamic(() =>
  import('./organisms/OffersAppContainer/index').then(mod => mod.OffersAppContainer)
);
export const AppTileSquare = dynamic(() => import('./organisms/AppTileSquare/index').then(mod => mod.AppTileSquare));
export const AppBenefitsBanner = dynamic(() =>
  import('./organisms/AppBenefitsBanner/index').then(mod => mod.AppBenefitsBanner)
);
export const AppPartnerCircle = dynamic(() =>
  import('./organisms/AppPartnerCircle/index').then(mod => mod.AppPartnerCircle)
);
//export * from './organisms/OffersAppContainer';

export const AppTileSkinny = dynamic(() => import('./organisms/AppTileSkinny/index').then(mod => mod.AppTileSkinny));
export const AppCheckInConfo = dynamic(() =>
  import('./organisms/AppCheckInConfo/index').then(mod => mod.AppCheckInConfo)
);
export const AppHomescreenTakeover = dynamic(() =>
  import('./organisms/AppHomescreenTakeover/index').then(mod => mod.AppHomescreenTakeover)
);
export const WebMerchandisingCardTile = dynamic(() =>
  import('./organisms/WebMerchandisingCardTile/index').then(mod => mod.WebMerchandisingCardTile)
);
export const WebMerchandisingTileSkinny = dynamic(() =>
  import('./organisms/WebMerchandizingTileSkinny/index').then(mod => mod.WebMerchandisingTileSkinny)
);
export const WebMerchandisingPartnerCard = dynamic(() =>
  import('./organisms/WebMerchandisingPartnerCard/index').then(mod => mod.WebMerchandisingPartnerCard)
);
export const WebMerchandisingBrandBanner = dynamic(() =>
  import('./organisms/WebMerchandisingBrandBanner/index').then(mod => mod.WebMerchandisingBrandBanner)
);
export const OfferCarousel = dynamic(() => import('./organisms/OfferCarousel').then(mod => mod.OfferCarousel));
export const WebMerchandisingPortalModal = dynamic(() =>
  import('./organisms/WebMerchandisingPortalModal/index').then(mod => mod.WebMerchandisingPortalModal)
);
export const WebMerchandisingSignInModal = dynamic(() =>
  import('./organisms/WebMerchandisingSignInModal/index').then(mod => mod.WebMerchandisingSignInModal)
);
